import { HairstudioRoutes } from "./config/HairstudioRoutes"
import { AcademyRoutes } from "./config/AcademyRoutes"
import { ErrorRoutes } from "./config/ErrorRoutes"

const routes = [
  ...HairstudioRoutes,
  ...AcademyRoutes,
  ...ErrorRoutes
]

export default routes